import { render, staticRenderFns } from "./DueTabs.vue?vue&type=template&id=d5e4ab96&"
import script from "./DueTabs.vue?vue&type=script&lang=js&"
export * from "./DueTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports